/* eslint-disable max-len */
import React from "react";

/**
 * A functional React component that renders a Checkbox SVG icon UI element.
 */
export const IconCheckbox: React.FC<{ isSelected?: boolean }> = ({ isSelected }) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="0.5"
            y="0.5"
            width="17"
            height="17"
            rx="3.5"
            fill={isSelected ? "#1D2D5A" : "white"}
            stroke="#BEC2CA"
        />
        {isSelected && (
            <path
                d="M7.33333 12.3333L3.5 8.49999L4.55833 7.44166L7.33333 10.2167L13.4417 4.10833L14.5 5.16666L7.33333 12.3333Z"
                fill="white"
            />
        )}
    </svg>
);
